const isEmpty = (v) => {
    return v === undefined || v !== v || v === null;
}
export const rules = {
    naturalNumber: v => /^[\+]?[1-9]\d*$|^0$/.test(v) ? true : "请输入非负整数！",
    number: v => /^[\+\-]?\d+(\.\d+)?$/.test(v) ? true : "请输入数字！",
    interger : v => /^[\+\-]?[1-9]\d*$|^0$/.test(v) ? true : "请输入整数！",
    "maxLength:*": n => v => (isEmpty(v) || `${v}`.length <= n) ? true : `最大长度${n}！`,
    "minLength:*": n => v => (isEmpty(v) || `${v}`.length >= n) ? true : `最小长度${n}！`,
    "mileage": v => /^[A-Za-z]+\d+\+\d{3}$/.test(v) ? true : "桩号格式不对！",
    "longitude": v => {
        let len = getRule("maxLength:10");
        let num = getRule("number");
        if (num(v) !== true) return num(v);
        if (len(v) !== true) return len(v);
        if (+v <= 180 && +v >= -180) return true;
        return "经度范围-180~180"
    },
    "latitude": v => {
        if (+v <= 90 && +v >= -90) return true;
        return "纬度范围-90~90"
    },
    "RangePicker": v => {
        const [start, end] = v || [];
        if (!start || !end) return "请选择开始时间和结束时间！"
        return true;
    }
}
export const addRule = (name, fn) => {
    rules[name] = fn;
}
export const getRule = (name) => {
    let n = name.split(":");
    let [f, t] = n;
    if (t !== undefined){
        let fn = rules[f + ":*"];
        return fn(t)
    }else{
        let fn = rules[f];
        return fn;
    }
}